
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AppConfig from '@/AppConfig';
import { Plan } from '@/classes/stripe';
import Icon from '@/components/Icons/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class DowngradeRestrictedModal extends Vue {
  @Prop(Boolean)
  open!: boolean;

  @Prop()
  newPlan!: Plan; //only set, when user selects to a new premium-plan

  @Prop()
  userCodeAmount!: number;

  oldBaseUrl: any = AppConfig.getOldAppBaseUrl();

  get returnRedirectUrl(): string {
    const url = `${AppConfig.getOldAppBaseUrl()}/upgrade/?showMangement=true&showTrackable=0&allowed=${
      this.newPlan ? this.newPlan.codeLimit : 1
    }&has=${this.userCodeAmount}`;
    return url;
  }

  cancel() {
    this.$emit('cancel');
  }

  @Watch('open')
  onOpenChange(open: boolean) {
    if (!open) {
      return;
    }
  }
}
